import React from 'react';

import * as appHelpers from '@src/services/helpers/appHelpers';
import { EPopup } from '@src/types/common';
import { classes, stylesheet } from 'typestyle';
import { setPopup } from '@src/state/popupAtoms';

import translation from './translation';

const lang = appHelpers.loadTranslation(translation);

export function OpenSettings() {
  return (
    <span
      className={sheet.openSettings}
      onClick={() => setPopup(EPopup.settings, true)}
    >
      <i className={classes('material-icons', 'notranslate', sheet.icon)}>
        open_in_new
      </i>
      {' '}
      {lang.opensettings}
    </span>
  );
}

const sheet = stylesheet({
  openSettings: {
    marginLeft: 20,
    color: '#47a0e6',
    cursor: 'pointer',
    transition: 'color 0.2s',
    $nest: {
      '&:hover': {
        textDecoration: 'underline',
        color: '#238de1',
      },
    },
  },
  icon: {
    verticalAlign: 'middle',
  },
});
